var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "credit-card--black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cart-desktop",
    transform: "translate(-1046.000000, -677.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "credit-card--black",
    transform: "translate(1046.000000, 677.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.894,0 L2.106,0 C0.942888317,0 0,0.94851618 0,2.11857018 L0,17.8814298 C0,18.4433096 0.221881506,18.9821762 0.616833119,19.3794852 C1.01178473,19.7767941 1.54745407,20 2.106,20 L23.894,20 C24.4525459,20 24.9882153,19.7767941 25.3831669,19.3794852 C25.7781185,18.9821762 26,18.4433096 26,17.8814298 L26,2.11857018 C26,1.55669044 25.7781185,1.01782382 25.3831669,0.62051484 C24.9882153,0.223205861 24.4525459,0 23.894,0 Z M2.106,1.31066027 L23.894,1.31066027 C24.336888,1.31225955 24.6955265,1.6730387 24.6971111,2.11857018 L24.6971111,4.27782621 L1.29711111,4.27782621 L1.29711111,2.11857018 C1.29787592,1.90352936 1.3835279,1.69760183 1.53522429,1.54609002 C1.68692068,1.3945782 1.89223509,1.30989337 2.106,1.31066027 Z M23.894,18.6893397 L2.106,18.6893397 C1.663112,18.6877405 1.30447348,18.3269613 1.30288889,17.8814298 L1.30288889,8.25632084 L24.7028889,8.25632084 L24.7028889,17.8814298 C24.7021241,18.0964706 24.6164721,18.3023982 24.4647757,18.45391 C24.3130793,18.6054218 24.1077649,18.6901066 23.894,18.6893397 L23.894,18.6893397 Z M13.2888889,11.4908457 L3.72088889,11.4908457 C3.40179103,11.4908457 3.14311111,11.2306218 3.14311111,10.9096193 C3.14311111,10.5886168 3.40179103,10.3283929 3.72088889,10.3283929 L13.2888889,10.3283929 C13.6079867,10.3283929 13.8666667,10.5886168 13.8666667,10.9096193 C13.8666667,11.2306218 13.6079867,11.4908457 13.2888889,11.4908457 Z M8.50488889,14.1063644 L3.72088889,14.1063644 C3.40179103,14.1063644 3.14311111,13.8461405 3.14311111,13.525138 C3.14311111,13.2041356 3.40179103,12.9439117 3.72088889,12.9439117 L8.50488889,12.9439117 C8.82398674,12.9439117 9.08266667,13.2041356 9.08266667,13.525138 C9.08266667,13.8461405 8.82398674,14.1063644 8.50488889,14.1063644 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardBlack);
export default __webpack_public_path__ + "static/media/credit-card--black.7598f0464eb81d4f7293a914dcffbfd0.svg";
export { ForwardRef as ReactComponent };